"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkTransfer__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "_token",
                type: "address",
            },
            {
                internalType: "address[]",
                name: "_to",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "amount",
                type: "uint256[]",
            },
        ],
        name: "send",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class BulkTransfer__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "BulkTransfer";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BulkTransfer__factory = BulkTransfer__factory;
BulkTransfer__factory.bytecode = _bytecode;
BulkTransfer__factory.abi = _abi;
